import isEmpty from "lodash/isEmpty";

export const serializePermissions = (permission) => {
  const [resource, intent, operation] = permission?.split(":") || [];
  return { resource, intent, operation };
};

export const serializeGraphqlFeaturePackagesData = ({
  packages,
  packageFeatures,
  permissionFlag,
} = {}) => {
  const featurePkgIdMapping = {};
  const processedPackages = packages.reduce((acc, pkg, index) => {
    acc[pkg.id] = {
      ...pkg,
      ...pkg?.packageDetail,
      ...pkg?.packageDetail?.preferences,
      slug: pkg?.intent,
      isHighestPackage: index === packages.length - 1,
      packageFeatureIds: pkg.packageFeatures.map(({ id }) => id),
      packageFeatureSlugs: pkg.packageFeatures.map(
        ({ id: featureId, intent, permissions = [""] }) => {
          if (!featurePkgIdMapping[featureId]) featurePkgIdMapping[featureId] = pkg.id;
          const { intent: permissionKey } = serializePermissions(permissions?.[0]);
          const key = permissionFlag ? permissionKey : intent;
          return key;
        },
      ),
      id: pkg.id,
    };
    return acc;
  }, {});

  const processedPackageFeatures = packageFeatures.reduce(
    (acc, { intent: slug, name, id: featureId, permissions = [""] }) => {
      const { intent: permissionKey } = serializePermissions(permissions?.[0]);
      const key = permissionFlag ? permissionKey : slug;
      acc[key] = { featureId: +featureId, slug, name, packageId: featurePkgIdMapping[featureId] };
      return acc;
    },
    {},
  );

  return {
    packages: processedPackages || {},
    packageFeatures: processedPackageFeatures || {},
  };
};

export const serializeGraphqlUserPackageFeatureData = ({
  activePackage,
  packages,
  permissions,
  permissionFlag,
}) => {
  const { packageFeatures, id, name } = activePackage || {};

  const featureAccessMap = (packageFeatures || []).reduce((acc, { intent: slug }) => {
    acc[slug] = {
      accessible: true,
      disabled: false,
      visible: true,
    };
    return acc;
  }, {});

  const permissionMap = (permissions || []).reduce((acc, resource) => {
    const { intent: slug } = serializePermissions(resource);
    acc[slug] = {
      accessible: true,
      disabled: false,
      visible: true,
    };
    return acc;
  }, {});

  const packageInfo = [{ id, name }];
  const currentPackage = isEmpty(activePackage)
    ? Object.values(packages || {}).find((pkg) => pkg.default)
    : {
        ...activePackage,
        ...activePackage?.packageDetail,
        ...activePackage?.packageDetail?.preferences,
        id: activePackage?.id,
      };

  return {
    currentPackage: currentPackage || {},
    featureAccessMap: permissionFlag ? permissionMap : featureAccessMap,
    packageInfo,
  };
};
